import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const BlogAuthContext = createContext(null);

export function BlogAuthProvider({ children }) {
  const [cmsUser, setCmsUser] = useState(null);
  const [cmsLoading, setCmsLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem('cms_token');
      if (!token) { setCmsUser(null); setCmsLoading(false); return; }
      const { data } = await axios.get(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCmsUser(data);
    } catch {
      localStorage.removeItem('cms_token');
      setCmsUser(null);
    } finally {
      setCmsLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const cmsLogin = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password });
    localStorage.setItem('cms_token', data.token);
    setCmsUser(data);
    return data;
  };

  const cmsLogout = () => {
    localStorage.removeItem('cms_token');
    setCmsUser(null);
  };

  return (
    <BlogAuthContext.Provider value={{ cmsUser, cmsLoading, cmsLogin, cmsLogout, checkAuth }}>
      {children}
    </BlogAuthContext.Provider>
  );
}

export function useBlogAuth() {
  return useContext(BlogAuthContext);
}

// API helper with auth
export function useBlogApi() {
  const getHeaders = () => {
    const token = localStorage.getItem('cms_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const api = {
    get: (url) => axios.get(`${API}${url}`, { headers: getHeaders() }),
    post: (url, data) => axios.post(`${API}${url}`, data, { headers: getHeaders() }),
    put: (url, data) => axios.put(`${API}${url}`, data, { headers: getHeaders() }),
    delete: (url) => axios.delete(`${API}${url}`, { headers: getHeaders() }),
  };

  return api;
}
